import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-businesstype-dropdown',
  templateUrl: './BusinessTypeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => BusinessTypeDropdownComponent)}]
})
export class BusinessTypeDropdownComponent extends BaseDropdownComponent {

    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getBusinessTypes().subscribe(x=> this.onGetBusinessTypesDone(x));
    }
    
    onGetBusinessTypesDone(items: ent.BusinessType[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
        if (this.selectedID){
            this.value = this.selectedID;
        }
        else{
            var defaultItems = items.filter(x=>x.ID == Constants._DEFAULT_CUSTOMER_TYPE_ID);
            if (defaultItems.length > 0){
                this.value = defaultItems[0].ID;
            }
        }
        this.loadDone.emit(this.value);
    }

}